import { useEffect, useLayoutEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { useHistory } from "react-router-dom";
import useMedia from "use-media";
import { useRtoaster } from "../../../hooks/useRtoaster";
import { default as commonUtil } from "../../../common/commonUtil";
import { apiKeyCheck, getFacilityInfo, versionGetApi } from "../../../const";
import messageConst from "../../../const/messageConst";
import img_save from '../../../resources/icons/ico_memo.svg';
import common from "../../../resources/js/common/common";
import VacancyContainer from "./vacancyContainer";
import { Label } from '../../atoms/label';
import LoginBfVacancyInfoCallender from "./loginBfVacancyInfoCallender";
import './../../../resources_membership_hotel/css/hotel/membership_vacancy.css';
import VacancyFacilityPopup from "./vacancyFacilityPopup";
import MultiSelectPopup from "../common/multiSelectPopup";
const rooms = [
    { id: "1", value: "1室", selected: true },
    { id: "2", value: "2室", selected: false },
    { id: "3", value: "3室", selected: false },
];

const MembershipVacancyContainer = (props) => {
    const {
        state,
        checkIn,
        checkOut,
        room,
        planConditions,
        // grade,
        food,
        privilegedService,
        restaurantInfo,
        membershipFacility,
        setRoom,
        setResvKaiinken,
        setCheckIn,
        setCheckOut,
        setPlanConditions,
        setGrade,
        setGradeData,
        gradeData,
        setFood,
        setPrivilegedService,
        setMembershipFacility,
        setMembershipSearchParam,
        resvKaiinken,
        login,
        adultNum,
        childNum,
        setAdultNum,
        setChildNum,
        onClickOpenSavedSearchCriteriaWindow,
        onClickOpenCalendarWindow,
        onClickOpenStartTimeWindow,
        onClickOpenCheckListWindow,
        onClickOpenFacilityCalendarWindow,
        setVacancyInfo,
        setVacancyWeek,
        vacancyWeek,
        setDispFacility,
        setDispDetailCondition,
        toHotelSearchView
    } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);

    const [displaySwitch, setDisplaySwitch] = useState(false);
    const vacancyInfo = state.vacancyInfo;
    // const [vacancyWeek, setVacancyWeek] = useState([]);
    const [MonthHead, setMonthHead] = useState("");
    const [MonthLast, setMonthLast] = useState("");
    const [firstDate, setFirstDate] = useState(null);

    const [linkList, setLinkList] = useState([]);

    const history = useHistory();
    const store = useStore();

    // エラー情報
    const [errorInfo, setErrorInfo] = useState({ errorMessage: null, errorFlg: false, });
    const [errFlgList, setErrFlgList] = useState({ errFacility: false, errPeopleNum: false, errAdultNum: false });

    // 施設ポップアップのデータ
    // 子コンポーネントにデータ取得しているが子コンポーネントにポップアップ配置するとレイアウトがおかしくなるのでここでState管理
    // getShisetsuGradeListレスポンスのshisetsuInfo＋選択、グループ開閉状態保持
    const [facilityData, setFacilityData] = useState(null);

    // 施設選択ポップアップ表示状態
    const [showFacilityPopup, setShowFacilityPopup] = useState(false);

    const openFacilityPopup = () => {
        setShowFacilityPopup(true);
    }
    const closeFacilityPopup = () => {
        setShowFacilityPopup(false);
    }

    // グレード選択ポップアップ表示状態
    const [showGradePopup, setShowGradePopup] = useState(false);

    const openGradePopup = () => {
        setShowGradePopup(true);
    }
    const closeGradePopup = () => {
        setShowGradePopup(false);
    }

    // rtoasterタグ生成
    useRtoaster();

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
    })

    // API呼出等事前処理
    useEffect(() => {
        setLinkList([{ path: "/reserve/top", label: "HOME" }]);
        // 直リンク想定なのでバージョンチェック不要
        // common.doPost(versionGetApi, {}, afterVerCheck);

        store.dispatch({ type: "DISP_FACILITY", payload: { dispFacility: "選択なし" } });
        store.dispatch({ type: "DISP_DETAIL_CONDITION", payload: { dispDetailCondition: "選択なし" } });

        // チェックイン・アウト日付初期化
        let iniCheckInDate = new Date();
        let iniCheckOutDate = new Date();
        iniCheckInDate.setDate(iniCheckInDate.getDate() + 3);
        iniCheckOutDate.setDate(iniCheckOutDate.getDate() + 4);
        setCheckIn(iniCheckInDate);
        setCheckOut(iniCheckOutDate);

        setFirstDate(new Date(iniCheckInDate.getFullYear(), iniCheckInDate.getMonth(), iniCheckInDate.getDate()));

        // 会員権情報設定処理
        let keiyakuNo = "";

        //resvから契約Noセット追記する
        resvKaiinken.forEach(value => {
            if (value.selected) {
                keiyakuNo = value.keiyakuNo;
            }
        })

        // login.memberInfo.forEach(info => {
        //     info.memberList.data.kaiinInfoList.forEach((value, index) => {
        //         if (index === 0) {
        //             keiyakuNo = value.keiyakuNo;
        //             kaiinkenList.push({ selected: true, keiyakuNo: value.keiyakuNo, id: value.ownerCd, value: value.ownerNo, kaiinkenSyubetCd: value.kaiinkenSyubetCd });
        //         } else {
        //             kaiinkenList.push({ selected: false, keiyakuNo: value.keiyakuNo, id: value.ownerCd, value: value.ownerNo, kaiinkenSyubetCd: value.kaiinkenSyubetCd });
        //         }
        //     })
        // })
        // setResvKaiinken(kaiinkenList);

        // 施設・部屋グレード情報取得
        common.doPost(getFacilityInfo, { keiyakuNo: keiyakuNo }, afterGetFacilityInfo);

        // 人数設定処理
        setAdultNum(commonUtil.getPeopleNumList(1, 5, 2));
        setChildNum(commonUtil.getPeopleNumList(0, 4, 0));
        // 室数設定処理
        setRoom(rooms);

    }, []);

    // const afterVerCheck = (res) => {
    //     let flg = common.versionCheck(res.data.version);
    //     if (flg) {
    //         history.push("/reserve/login");
    //         return;
    //     }
    // }

    // 施設・部屋グレード情報取得後処理
    const afterGetFacilityInfo = (res) => {
        const data = res.data;
        if (data.resultCode === '0') {
            const memberHotelList = [];
            data.shisetsuInfo?.memberHotelList && data.shisetsuInfo.memberHotelList.forEach(main => {
                let list = [];
                main.shisetsuList.forEach(membership => {
                    let membershipObj = { class: "facility", id: membership.shisetsuCd, value: membership.shisetsuName, checked: false, disabled: !membership.enable, openFlg: membership.openFlg, openingDate: membership.openingDate }
                    list.push(membershipObj);
                })
                let mainBuildingObj =
                {
                    mainGroupCd: main.mainGroupCd,
                    mainGroupName: main.mainGroupName,
                    checked: false,
                    displayFlg: false,
                    disabled: main.honkanShisetsuRiyoFlg,
                    shisetsuList: list
                };
                memberHotelList.push(mainBuildingObj);
            })

            const generalHotelList = [];
            data.shisetsuInfo?.generalHotelList && data.shisetsuInfo.generalHotelList.forEach(main => {
                const list = [];
                main.shisetsuList.forEach(ippan => {
                    let ippanObj = { class: "facility", id: ippan.shisetsuCd, value: ippan.shisetsuName, checked: false, disabled: !ippan.enable }
                    list.push(ippanObj);
                })
                let mainBuildingObj =
                {
                    mainGroupCd: main.mainGroupCd,
                    mainGroupName: main.mainGroupName,
                    checked: false,
                    displayFlg: false,
                    disabled: false,
                    shisetsuList: list
                };
                generalHotelList.push(mainBuildingObj);
            })
            setMembershipFacility({ membership: memberHotelList, ippan: generalHotelList });

            const grades = [];
            data.roomGradeList.forEach(value => {
                const item = { class: "gradeList", id: value.gradeCd, value: value.gradeName, checked: false, disabled: !value.enable }
                grades.push(item);
            })
            setGrade(grades);

            const planConditionsList = [];
            data.planConditionsList.forEach(value => {
                const item = { class: "planConditions", id: value.planConditionsCd, value: value.planConditionsName, checked: false, disabled: !value.enable }
                planConditionsList.push(item);
            })
            setPlanConditions(planConditionsList);

            const foodList = [];
            data.foodList.forEach(value => {
                const item = { class: "foodList", id: value.foodCd, value: value.foodName, checked: false, disabled: !value.enable }
                foodList.push(item);
            })
            setFood(foodList);

            const privilegedServiceList = [];
            data.privilegedServiceList.forEach(value => {
                let item = { class: "privilegedService", id: value.privilegedServiceCd, value: value.privilegedServiceName, checked: false, disabled: false, description: value.privilegedServiceText }
                privilegedServiceList.push(item);
            })
            setPrivilegedService(privilegedServiceList);
        }
    }

    return (<>
        <div style={style.top}>
            <div style={isMobilePhone ? style.wrapperMobile : style.wrapper}>
                <div id="callender" style={isMobilePhone ? style.wrapperContainerMobile : style.wrapperContainer}>
                    <div style={isMobilePhone ? style.searchboxMobile : style.searchbox}>
                        <VacancyContainer
                            onClickCheckIn={onClickOpenCalendarWindow}
                            onClickOpenStartTimeWindow={onClickOpenStartTimeWindow}
                            displaySwitch={false}
                            setVacancyInfo={setVacancyInfo}
                            setVacancyWeek={setVacancyWeek}
                            MonthHead={MonthHead}
                            setMonthHead={setMonthHead}
                            setMonthLast={setMonthLast}
                            firstDate={firstDate}
                            onClickOpenCheckListWindow={onClickOpenCheckListWindow}
                            facilityData={facilityData}
                            setFacilityData={setFacilityData}
                            openGradePopup={openGradePopup}
                            openFacilityPopup={openFacilityPopup}
                        />
                    </div>
                </div>
                <LoginBfVacancyInfoCallender
                    onClickPlay={onClickOpenCalendarWindow}
                    onClickOpenStartTimeWindow={onClickOpenStartTimeWindow}
                    onClickOpenFacilityCalendarWindow={onClickOpenFacilityCalendarWindow}
                    displaySwitch={displaySwitch}
                    vacancyInfo={vacancyInfo}
                    vacancyWeek={vacancyWeek}
                    MonthHead={MonthHead}
                    MonthLast={MonthLast}
                    firstDate={firstDate}
                    toHotelSearchView={toHotelSearchView}
                    facilityData={facilityData}
                    style={isMobilePhone ? style.wrapperCallenderMobile : style.wrapperCallender}
                />
            </div>
        </div>
        <VacancyFacilityPopup initialShisetsuInfo={facilityData} onDecice={(facility) => {
            setFacilityData(facility);
            setShowFacilityPopup(false);
        }} onClose={closeFacilityPopup} show={showFacilityPopup} />
        <MultiSelectPopup initialData={gradeData} onDecice={(data) => {
            setGradeData(data);
            setShowGradePopup(false);
        }} onClose={closeGradePopup} show={showGradePopup}
            idPrefix="vacancy_grade"
            popupTitle={"グレード"}
            title={"部屋条件"}
        />
    </>

    );
};


const style = {
    top: {
        //paddingBottom: "50px",
    },

    wrapper: {
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        textAlign: "center",
        width: "80%",
        margin: "50px auto",
        fontSize: "80%",
        paddingBottom: "50px",
    },
    wrapperMobile: {
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        textAlign: "center",
        width: "90%",
        margin: "auto",
        marginTop: "40px",
        fontSize: "90%",
    },
    wrapperContainerMobile: {
        padding: "20px 5%",
    },
    wrapperContainer: {},
    wrapperCallenderMobile: {
        width: "100%",
        margin: "0px 0px 40px",
    },
    wrapperCallender: {
        width: "80%",
        paddingTop: "20px",
        margin: "0px auto"
    },
    titleArea: {
        display: "flex",
        alignContent: "center",
        justifyContent: "space-between",
    },
    keepLink: {
        color: "#adadad",
        textDecoration: "underline",
        fontSize: "small",
        marginTop: "23px",
        cursor: "pointer",
        backgroundImage: `url(${img_save})`,
        backgroundPosition: 'left 0 bottom 1%',
        backgroundSize: '20%',
        backgroundRepeat: "no-repeat",
        padding: "0 0 0 5px",
        textDecorationThickness: "2px"
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
    },
    tabnavi: {
        backgroundColor: "#fff",
        haight: "auto",
        justifyContent: "center",
        display: "flex",
        border: "1px solid #eee"
    },
    breadCrumb: {
        display: "flex",
        color: "white",
        margin: "8px auto 20px auto",
        width: "60%",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    searchbox: {
        width: "80%",
        margin: "0px auto",
        paddingTop: "20px",
    },
    searchboxMobile: {
        width: "100%",
        paddingTop: "0px",
    },
    searchboxMobile2: {
        width: "calc(100% + 20px)",
        margin: "0px 0px 0px -10px",
    },
    errorMassage: {
        display: "inline-block",
        textAlign: "center",
        padding: "15px 0px 0px 0px",
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0)",
        border: 0,
        fontWeight: "bold"
    },
    footerLabel: {
        width: "100%",
        margin: "0 auto",
        //marginTop: "50px",
        textAlign: "center",
        color: "gray",
        padding: "30px 0px 20px 0px"
    },
    footerLabel2: {
        width: "90%",
        margin: "0 0 0 5%",
        //marginTop: "50px",
        textAlign: "center",
        fontSize: "0.7em",
        color: "gray",
        padding: "2rem 0px 10px",
    },
};

const mapStateToProps = (state) => {
    return {
        checkIn: state.checkIn,
        checkOut: state.checkOut,
        login: state.login,
        resvKaiinken: state.resvKaiinken,
        room: state.room,
        adultNum: state.adultNum,
        childNum: state.childNum,
        planConditions: state.planConditions,
        grade: state.grade,
        gradeData: state.gradeData,
        food: state.food,
        vacancyWeek: state.vacancyWeek,
        privilegedService: state.privilegedService,
        membershipFacility: state.membershipFacility,
        restaurantInfo: state.restaurantInfo
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
        setResvKaiinken: (item) => {
            dispatch({ type: "RESV_KAIINKEN", payload: { resvKaiinken: item } })
        },
        setRoom: (item) => {
            dispatch({ type: "ROOM", payload: { room: item } })
        },
        setCheckIn: (item) => {
            dispatch({ type: "CHECKIN", payload: { checkIn: item } })
        },
        setCheckOut: (item) => {
            dispatch({ type: "CHECKOUT", payload: { checkOut: item } })
        },
        setAdultNum: (item) => {
            dispatch({ type: "ADULT_NUM", payload: { adultNum: item } })
        },
        setChildNum: (item) => {
            dispatch({ type: "CHILD_NUM", payload: { childNum: item } })
        },
        setGrade: (item) => {
            dispatch({ type: "GRADE", payload: { grade: item } })
        },
        setPlanConditions: (item) => {
            dispatch({ type: "PLAN_CONDITIONS", payload: { planConditions: item } })
        },
        setPrivilegedService: (item) => {
            dispatch({ type: "PRIVILEGED_SERVICE", payload: { privilegedService: item } })
        },
        setFood: (item) => {
            dispatch({ type: "FOOD", payload: { food: item } })
        },
        setMembershipFacility: (item) => {
            dispatch({ type: "MEMBERSHIP_FACILITY", payload: { membershipFacility: item } })
        },
        setMembershipSearchParam: (item) => {
            dispatch({ type: "MEMBERSHIP_SEARCH_PARAM", payload: { membershipSearchParam: item } })
        },
        setRestauraantInfo: (item) => {
            dispatch({ type: "RESTAURANT_INFO", payload: { restrauntInfo: item } })
        },
        setDispFacility: (item) => {
            dispatch({ type: "DISP_FACILITY", payload: { dispFacility: item } })
        },
        setDispDetailCondition: (item) => {
            dispatch({ type: "DISP_DETAIL_CONDITION", payload: { dispDetailCondition: item } })
        },
        setVacancyWeek: (weekList) => {
            dispatch({ type: "VACANCY_WEEK", payload: { vacancyWeek: weekList } });
        },
        setGradeData: (item) => {
            dispatch({ type: "GRADE_DATA", payload: { gradeData: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(MembershipVacancyContainer);